import { ReactNode, forwardRef } from "react";
import * as React from "react";
import cn from "classnames";
import Button, { ButtonStyle } from "@ebsco-ui/button";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import { useShowMoreContext } from "../show-more-context";

export interface ShowMoreButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  collapseContent: ReactNode;
  expandContent: ReactNode;
  styleType?: ButtonStyle;
  className?: string;
}

const ShowMoreButton = forwardRef<HTMLButtonElement, ShowMoreButtonProps>(
  (
    {
      expandContent,
      collapseContent,
      styleType = "inline",
      className,
      ...rest
    }: ShowMoreButtonProps,
    forwardedRef,
  ) => {
    const { isExpanded, toggleIsExpanded, totalItems, limit } =
      useShowMoreContext();

    if (totalItems <= limit) {
      return null;
    }

    const getClassNames = () => {
      const getBlocksWith = createBemBlockBuilder([
        "eb-show-more-button",
        className,
      ]);

      return cn(
        getBlocksWith(),
        isExpanded ? getBlocksWith("--expanded") : getBlocksWith("--collapsed"),
      );
    };

    return (
      <Button
        ref={forwardedRef}
        className={getClassNames()}
        onClick={toggleIsExpanded}
        styleType={styleType}
        type="button"
        {...rest}
      >
        {isExpanded ? collapseContent : expandContent}
      </Button>
    );
  },
);

ShowMoreButton.displayName = "ShowMoreButton";

export default ShowMoreButton;
